/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Fab,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  useMediaQuery,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useForm } from 'react-hook-form';

import { Autocomplete } from '@material-ui/lab';
import OptionProductData from './OptionProductData';
import { yup } from '../constants';
import {
  useCategories,
  useDepartments,
  useEmployees,
  useProducts,
  useServices,
  useTemplate,
} from '../hooks';
import ListboxComponent from '../components/fields/ListboxComponent';
import PopupServiceItem from '../pubups/PopupServiceItem';
import { messageAlert } from './helpers';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import useTasks from '../hooks/useTasks';
import useResourses from '../hooks/useResourses';
import { SelectMobile } from '../pages/calendar/common/SelectMobile';
import _ from 'lodash';
import { GlobalContext } from '../contexts';

export default function ServiceItemForm({
  services,
  products,
  addItem,
  words,
  classes,
  user,
  isRTL,
  setAlrt,
  itemtype,
  taskv,
  isPurchase = false,
  issale,
  itemrelations,
  datelist,
  day,
}: any) {
  const [itemError, setItemError] = useState<any>(false);

  const [itemvalue, setItemvalue] = useState<any>(null);
  const [itemqty, setItemqty] = useState(1);
  const [itemprice, setItemprice] = useState(0);
  const [openItem, setOpenItem] = useState(false);
  const [newtext, setNewtext] = useState('');
  const [desc, setDesc] = useState('');

  const [taskvalue, setTaskvalue] = useState<any>(null);
  const [departvalue, setDepartvalue] = useState<any>(null);
  const [emplvalue, setEmplvalue] = useState<any>(null);
  const [resovalue, setResovalue] = useState<any>(null);
  const [catvalue, setCatvalue] = useState<any>(null);

  const [items, setItems] = useState([]);

  const { register, handleSubmit, errors } = useForm(yup.invItemResolver);
  const {
    store: { minstock },
  } = useContext(GlobalContext);
  const itemRef: any = React.useRef();
  const { addService, editService } = useServices();
  const { addProduct, editProduct } = useProducts();
  const { tempoptions, tempwords } = useTemplate();
  const { departments } = useDepartments();
  const { wemployees: employees } = useEmployees();
  const { resourses } = useResourses();

  const { tasks } = useTasks();
  const { categories } = useCategories();
  const isMobile = useMediaQuery('(max-width:600px)');

  const [type, setType] = useState(
    itemtype ? itemtype : tempoptions?.productsdef ? 1 : 2
  );
  useEffect(() => {
    if (type === 2) {
      const orderedServices = _.orderBy(services, 'barcode');
      setItems(orderedServices);
      setItemvalue(null);
      setCatvalue(null);
    } else if (type === 1) {
      const orderedProducts = _.orderBy(products, 'barcode');
      setItems(orderedProducts);
      setItemvalue(null);
      setCatvalue(null);
    }
  }, [type, services, products]);
  useEffect(() => {
    const allitems = type === 2 ? services : products;
    if (catvalue) {
      const nitems = allitems.filter(
        (it: any) => it.categoryId === catvalue?._id
      );
      const orderedItems = _.orderBy(nitems, 'barcode');
      setItems(orderedItems);
    } else {
      const orderedallitems = _.orderBy(allitems, 'barcode');
      setItems(orderedallitems);
    }
  }, [catvalue]);

  useEffect(() => {
    setTaskvalue(taskv);
  }, [taskv]);

  const onCloseItem = () => {
    setOpenItem(false);
    setNewtext('');
  };

  const onChangeCategory = (e: any) => {
    setCatvalue(e.target.value);
    setItemvalue(null);
  };

  const onNewItemChange = (nextValue: any) => {
    setItemvalue(nextValue);
    setItemprice(
      isPurchase && nextValue.itemType === 1
        ? nextValue?.cost
        : nextValue?.price || 0
    );
  };

  const resetAll = () => {
    setItemprice(0);
    setItemqty(1);
    setItemvalue(null);
    setDesc('');
    if (!taskv) {
      setTaskvalue(null);
    }
    setDepartvalue(null);
    setEmplvalue(null);
    setResovalue(null);
    // setCatvalue(null);
  };

  const addLocalItem = async () => {
    if (!itemvalue) {
      setItemError(true);
      if (!isMobile) itemRef.current.focus();
      return;
    }
    if (issale && itemvalue.itemType === 1 && itemvalue.quantity < itemqty) {
      await messageAlert(
        setAlrt,
        isRTL ? 'لا يوجد كمية في المخزن' : 'No stock avaliable'
      );
      return;
    }

    const itemdata = {
      ...itemvalue,
      itemqty,
      itemprice,
      itemtotal: Math.round(itemqty * itemprice),
      itemtotalcost: itemqty * itemvalue.cost,
      contractId: taskvalue?._id,
      contractName: taskvalue?.name,
      contractNameAr: taskvalue?.nameAr,
      departmentId: departvalue?._id,
      departmentName: departvalue?.name,
      departmentNameAr: departvalue?.nameAr,
      departmentColor: departvalue?.color,
      employeeId: emplvalue?._id,
      employeeName: emplvalue?.name,
      employeeNameAr: emplvalue?.nameAr,
      employeeColor: emplvalue?.color,
      employeePhone: emplvalue?.phone,
      resourseId: resovalue?._id,
      resourseName: resovalue?.name,
      resourseNameAr: resovalue?.nameAr,
      resourseColor: resovalue?.color,
      userId: user?._id,
      note: desc,
    };
    addItem(itemdata);
    resetAll();
    if (!isMobile) itemRef.current.focus();
  };

  const name = type === 1 ? words.product : words.service;
  return (
    <Box
      display="flex"
      style={{
        flex: 1,
        margin: 5,
        borderRadius: 5,
        alignItems: 'center',
        flexDirection: isMobile ? 'column' : 'row',
      }}
    >
      <RadioGroup
        row={isMobile}
        aria-label="Views"
        name="views"
        value={type}
        onChange={(e: any) => setType(Number(e.target.value))}
      >
        <FormControlLabel
          value={2}
          control={<Radio color="primary" />}
          label={words.services}
        />
        {tempoptions?.products && (
          <FormControlLabel
            value={1}
            control={<Radio color="primary" />}
            label={words.products}
          />
        )}
      </RadioGroup>
      <Box display="flex" style={{ flex: 1 }}>
        <Grid container spacing={1}>
          <Grid xs={12}>
            <Grid container spacing={1}>
              <Grid xs={12} md={2}>
                {isMobile ? (
                  <SelectMobile
                    options={categories.filter(
                      (dep: any) => dep.catType === type
                    )}
                    value={catvalue}
                    onChange={onChangeCategory}
                    isRTL={isRTL}
                    fullWidth
                    label={isRTL ? 'التصنيف' : 'Category'}
                  ></SelectMobile>
                ) : (
                  <Autocomplete
                    autoSelect
                    size="small"
                    options={categories.filter(
                      (dep: any) => dep.catType === type
                    )}
                    ListboxComponent={ListboxComponent}
                    getOptionLabel={(option: any) =>
                      `${isRTL ? option.nameAr : option.name}`
                    }
                    getOptionSelected={(option, values) =>
                      option._id === values._id
                    }
                    renderOption={(option) => (
                      <OptionProductData
                        isRTL={isRTL}
                        item={option}
                        price={false}
                      ></OptionProductData>
                    )}
                    fullWidth
                    value={catvalue}
                    onChange={(_, newValue: any) => {
                      setCatvalue(newValue);
                      setItemvalue(null);
                    }}
                    style={{ direction: isRTL ? 'rtl' : 'ltr', marginTop: 4 }}
                    classes={{ input: classes.smallFont }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="category"
                        name="category"
                        label={words.category}
                        error={itemError}
                        variant="outlined"
                        fullWidth
                        inputRef={(ref) => {
                          itemRef.current = ref;
                        }}
                        InputLabelProps={{
                          style: { fontSize: isRTL ? 16 : 13 },
                        }}
                      ></TextField>
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {!isMobile ? (
                  <Autocomplete
                    autoSelect
                    size="small"
                    options={items}
                    ListboxComponent={ListboxComponent}
                    getOptionLabel={
                      (option: any) =>
                        `${isRTL ? option.nameAr : option.name} ${
                          option.barcode
                        }`
                      // `${isRTL ? option.nameAr : option.name}`
                    }
                    getOptionSelected={(option, values) =>
                      option._id === values._id
                    }
                    renderOption={(option) => (
                      <OptionProductData
                        isRTL={isRTL}
                        item={option}
                        isPurchase={isPurchase}
                        minstock={minstock}
                        price
                      ></OptionProductData>
                    )}
                    fullWidth
                    value={itemvalue}
                    onChange={(_, newValue: any) => {
                      setItemvalue(newValue);
                      setItemprice(
                        isPurchase && newValue.itemType === 1
                          ? newValue?.cost
                          : newValue?.price || 0
                      );
                      if (newValue) {
                        setItemError(false);
                      }
                    }}
                    style={{ direction: isRTL ? 'rtl' : 'ltr' }}
                    classes={{ input: classes.smallFont }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="product"
                        name="product"
                        label={name}
                        error={itemError}
                        variant="outlined"
                        fullWidth
                        inputRef={(ref) => {
                          itemRef.current = ref;
                        }}
                        InputLabelProps={{
                          style: { fontSize: isRTL ? 16 : 13 },
                        }}
                      ></TextField>
                    )}
                  />
                ) : (
                  <SelectMobile
                    options={items}
                    value={itemvalue}
                    onChange={(e: any) => {
                      const newValue = e.target.value;
                      setItemvalue(newValue);
                      setItemprice(
                        isPurchase && newValue.itemType === 1
                          ? newValue?.cost
                          : newValue?.price || 0
                      );
                      if (newValue) {
                        setItemError(false);
                      }
                    }}
                    isRTL={isRTL}
                    fullWidth
                    label={name}
                  ></SelectMobile>
                )}
              </Grid>
              <Grid item xs={12} md={1}>
                <TextField
                  name="qty"
                  onChange={(e: any) => setItemqty(Number(e.target.value))}
                  value={itemqty}
                  label={words.qty}
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  error={errors.qty ? true : false}
                  margin="dense"
                  onFocus={(e) => e.target.select()}
                  inputProps={{
                    style: { textAlign: 'right', fontSize: 13, height: 13 },
                    inputMode: 'decimal',
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={10} md={2}>
                <div>
                  <TextField
                    name="price"
                    onChange={(e: any) => setItemprice(Number(e.target.value))}
                    value={itemprice}
                    label={words.theprice}
                    error={errors.price ? true : false}
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    fullWidth
                    margin="dense"
                    onFocus={(e) => e.target.select()}
                    inputProps={{
                      style: {
                        textAlign: 'right',
                        fontSize: 13,
                        height: 13,
                      },
                      inputMode: 'decimal',
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={2} md={1}>
                <Fab
                  style={{
                    marginLeft: 10,
                    marginTop: 5,
                    width: 36,
                    height: 36,
                  }}
                  color="primary"
                  onClick={handleSubmit(addLocalItem)}
                  title="Create new row"
                >
                  <AddIcon />
                </Fab>
              </Grid>
              {tempoptions?.itemdescription && (
                <Grid item xs={12} md={11}>
                  <div>
                    <TextField
                      name="desc"
                      onChange={(e: any) => setDesc(e.target.value)}
                      value={desc}
                      label={words.description}
                      variant="outlined"
                      margin="dense"
                      onFocus={(e) => e.target.select()}
                      fullWidth
                      multiline
                      rowsMax={2}
                      rows={2}
                      style={{ marginTop: 0 }}
                    />
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
          {itemrelations && (
            <>
              {tempoptions?.contract && (
                <Grid item xs={12} md>
                  <AutoFieldLocal
                    name="task"
                    title={tempwords?.task}
                    words={words}
                    options={tasks}
                    value={taskvalue}
                    setSelectValue={setTaskvalue}
                    isRTL={isRTL}
                    fullWidth
                    disabled={taskv ? true : false}
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
              {tempoptions?.employee && (
                <Grid item xs={12} md>
                  <AutoFieldLocal
                    name="employee"
                    title={tempwords?.employee2}
                    words={words}
                    options={employees.filter((emp: any) => !emp.disabled)}
                    value={emplvalue}
                    setSelectValue={setEmplvalue}
                    isRTL={isRTL}
                    fullWidth
                    datelist={datelist}
                    day={day}
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
              {tempoptions?.department && (
                <Grid item xs={12} md>
                  <AutoFieldLocal
                    name="department"
                    title={tempwords?.department}
                    words={words}
                    options={departments.filter((d: any) => d.depType === 1)}
                    value={departvalue}
                    setSelectValue={setDepartvalue}
                    isRTL={isRTL}
                    fullWidth
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
              {tempoptions?.resourse && (
                <Grid item xs={12} md>
                  <AutoFieldLocal
                    name="resourse"
                    title={tempwords?.resourse}
                    words={words}
                    options={resourses.filter((emp: any) => !emp.disabled)}
                    value={resovalue}
                    setSelectValue={setResovalue}
                    isRTL={isRTL}
                    fullWidth
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
            </>
          )}
        </Grid>

        <PopupServiceItem
          newtext={newtext}
          open={openItem}
          onClose={onCloseItem}
          isNew={true}
          setNewValue={onNewItemChange}
          row={null}
          resType={1}
          type={type}
          addAction={type === 2 ? addService : addProduct}
          editAction={type === 2 ? editService : editProduct}
        ></PopupServiceItem>
      </Box>
    </Box>
  );
}
